// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"928d976a","239":"0519312b","389":"9f69aca1","409":"e30a28ca","453":"2e895536","732":"b90e22dc","857":"fabab4d7","901":"1f1315d4","977":"3541049e"}[chunkId] + ".chunk.js";
};